import type { ContentType } from "@prisma/client"

export const CONTENT_TYPE: Record<ContentType, string> = {
  DAILY: "Daily",
  INDUSTRY: "Industry",
  INNOVATION: "Innovation",
  MACROTREND: "Macro-Trend",
  MEGATREND: "Mega-Trend",
  REGION: "Region",
  REPORT: "Report",
  STAT: "Stat",
  SUBTREND: "Sub-Trend",
  TOPIC: "Topic",
  GENERATION_RESULT: "Generation",
}
